module.exports = __webpack_public_path__ + "img/1138020568.5b0a93e7.jpg";